import { Search, MapPin, Wrench, BarChart3, ArrowRight } from "lucide-react";

const steps = [
    {
        week: "Week 1",
        icon: Search,
        title: "Discovery call",
        desc: "30-minute scoping session — environment, scale, funding sources, and timeline. No commitment.",
    },
    {
        week: "Week 2",
        icon: MapPin,
        title: "Site assessment",
        desc: "We map placement, integrations, training needs, and reporting requirements with your team.",
    },
    {
        week: "Week 3",
        icon: Wrench,
        title: "Install & train",
        desc: "Units delivered, mounted, and commissioned. On-site or virtual staff training included.",
    },
    {
        week: "Week 4",
        icon: BarChart3,
        title: "Live + reporting",
        desc: "Units active. Real-time telemetry dashboard delivered. Outcome reports ready for boards and stakeholders.",
    },
];

export const Timeline = () => {
    return (
        <section
            id="timeline"
            data-testid="timeline-section"
            className="relative bg-white py-28 md:py-36"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
                    <div className="max-w-2xl">
                        <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                            What Happens Next
                        </span>
                        <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-[#0A1428] text-balance">
                            From inquiry to
                            <br />
                            live deployment
                            <br />
                            <span className="text-[#F0493E]">in 30 days.</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-base md:text-lg text-slate-600 font-medium leading-relaxed">
                        We&apos;ve engineered the partnership process to be as
                        fast and frictionless as the device itself.
                    </p>
                </div>

                <div className="mt-20 relative">
                    {/* Connector line */}
                    <div className="hidden lg:block absolute top-6 left-6 right-6 h-px bg-slate-200" />
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 relative">
                        {steps.map((s, i) => (
                            <div
                                key={s.week}
                                data-testid={`timeline-step-${i}`}
                                className="reveal relative"
                                style={{ transitionDelay: `${i * 80}ms` }}
                            >
                                {/* Node */}
                                <div className="flex items-center gap-4 lg:block">
                                    <div className="relative h-12 w-12 grid place-items-center bg-white border border-[#0A1428] z-10">
                                        <s.icon
                                            size={20}
                                            strokeWidth={1.5}
                                            className="text-[#F0493E]"
                                        />
                                    </div>
                                </div>
                                <div className="mt-6 lg:mt-8">
                                    <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                                        {s.week}
                                    </div>
                                    <h3 className="mt-2 font-display font-bold text-xl md:text-2xl text-[#0A1428]">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-sm md:text-[15px] text-slate-600 leading-relaxed font-medium">
                                        {s.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="reveal mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 bg-[#0A1428] text-white p-8 md:p-10">
                    <div>
                        <div className="text-[10px] font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                            Ready when you are
                        </div>
                        <div className="mt-2 font-display font-bold text-xl md:text-2xl">
                            Start the discovery call this week.
                        </div>
                    </div>
                    <button
                        data-testid="timeline-cta"
                        onClick={() => {
                            window.dispatchEvent(
                                new CustomEvent("kairos:set-inquiry", {
                                    detail: "demo",
                                })
                            );
                            document
                                .getElementById("contact")
                                ?.scrollIntoView({ behavior: "smooth" });
                        }}
                        className="btn-primary inline-flex items-center justify-center gap-3 px-7 py-3.5 text-sm font-bold tracking-wide uppercase rounded-sm"
                    >
                        Book my call
                        <ArrowRight size={16} strokeWidth={2} />
                    </button>
                </div>
            </div>
        </section>
    );
};
